// ================= 关键词轮播条 =================
export const keywordTicker: { word: string; type: "hot" | "up" | "normal" }[] = [
  { word: "17吃瓜精选", type: "hot" },
  { word: "17吃瓜排行", type: "up" },
  { word: "17吃瓜盘点", type: "normal" },
  { word: "17吃瓜合集", type: "up" },
  { word: "17吃瓜汇总", type: "hot" },
  { word: "17吃瓜推荐", type: "normal" },
];

// ================= 导航 =================
export const navLinks: { label: string; anchor: string }[] = [
  { label: "精选聚焦", anchor: "#jingxuan" },
  { label: "吃瓜合集", anchor: "#heji" },
  { label: "快讯汇总", anchor: "#huizong" },
  { label: "年度盘点", anchor: "#pandian" },
  { label: "人气排行", anchor: "#paihang" },
  { label: "编辑推荐", anchor: "#tuijian" },
];

// ================= 首屏主瓜（文案优先 + 视觉陪衬） =================
export const heroHeadline: string[] = [
  "全网热门瓜料，一份能翻的合集",
  "今天又在 17 吃瓜把进度补上了",
];

export const heroLead =
  "把散落在各处的热搜、八卦与时事，按合集与汇总的方式重新码好——划拉之间，就有吃瓜进度条在前头。"

export const heroQuick = [
  "午间首发瓜已更新",
  "今日 17 条新增线索",
  "红榜换榜 3 次",
  "神反转专区加急中",
];

export const heroFeature = {
  tag: "今日焦点",
  title: "一瓜三转：同一件事的三面说法，谁在带节奏？",
  desc: "把时间线摊平来看，出场顺序和爆料口吻都很有讲究。这份 17吃瓜盘点式拆解，帮你把反转前后的关键节点一次看懂。",
  meta: "精选档案 · 约 12 分钟",
  cover: "https://readdy.ai/api/search-image?query=Stylized%20editorial%20flat%20vector%20illustration%20of%20a%20vintage%20broadcast%20microphone%20surrounded%20by%20stage%20spotlights%2C%20magnifying%20glass%20and%20bold%20star%20bursts%2C%20minimal%20collage%20layout%20on%20a%20warm%20cream%20background%20with%20vermilion%20red%20and%20amber%20gold%20geometric%20shapes%2C%20entertainment%20gossip%20magazine%20cover%20art%2C%20high%20contrast%2C%20soft%20paper%20grain%20texture%2C%20no%20recognizable%20people&width=800&height=1000&seq=hero-portrait-2026&orientation=portrait",
};

// ================= 人气排行（排行） =================
export const rankingList: {
  rank: number;
  title: string;
  heat: string;
  delta: "up" | "down" | "new";
  tag: string;
}[] = [
  { rank: 1, title: "年度瓜王候选：连播三天的连续剧式回应", heat: "982万", delta: "up", tag: "神反转" },
  { rank: 2, title: "旧采访被重新翻译，评论区连夜考古", heat: "874万", delta: "new", tag: "考古" },
  { rank: 3, title: "同框即热搜：一张路透带飞两家热搜", heat: "801万", delta: "up", tag: "路透" },
  { rank: 4, title: "节目剪出来的名场面，正片却在另一层", heat: "766万", delta: "down", tag: "节目" },
  { rank: 5, title: "澄清文配图比例失调，网友逐帧抠细节", heat: "703万", delta: "up", tag: "澄清" },
  { rank: 6, title: "颁奖礼座位图引发的排位学", heat: "651万", delta: "down", tag: "红毯" },
  { rank: 7, title: "联动文案集体踩点，品牌也会追热点", heat: "588万", delta: "new", tag: "商业" },
  { rank: 8, title: "旧照重发又秒删，线索再+1", heat: "540万", delta: "up", tag: "考古" },
  { rank: 9, title: "路透视频里的一个眼神被放大十倍", heat: "498万", delta: "down", tag: "路透" },
  { rank: 10, title: "评论区吵了三万条，还是没吵明白", heat: "436万", delta: "down", tag: "讨论" },
];

export const risingSide = [
  { title: "站姐手写信刷屏，正主只回了两个表情", tag: "温情" },
  { title: "名场面二创大赛，官方下场翻牌", tag: "创作" },
  { title: "旧综艺cut被顶上热一，数据好到吓人", tag: "考古" },
];

// ================= 精选聚焦（精选） =================
export const spotlight = {
  badge: "17吃瓜精选 · 深度",
  title: "从一条爆料到全员回应，这一周发生了什么",
  lead: "把时间线、出处与每轮口径做成一张便于扫读的进度卡，再给出我们整理出的三条主线。",
  bullets: ["首次发声后的 6 小时内出现两轮反转", "多方说法并存，关键证据仍在路上", "衍生二创与表情包反而最先出圈"],
  cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20scene%20of%20a%20backstage%20red%20carpet%20with%20velvet%20rope%2C%20golden%20bokeh%20stage%20lights%2C%20film%20clapperboard%20and%20silhouetted%20reporters%20holding%20cameras%2C%20minimal%20geometric%20collage%2C%20warm%20cream%20and%20terracotta%20palette%20with%20deep%20red%20and%20amber%20accents%2C%20newspaper%20grain%20texture%2C%20high%20detail%2C%20no%20recognizable%20faces%2C%20magazine%20feature%20art&width=1200&height=800&seq=spotlight-wide-2026&orientation=landscape",
};

export const spotlightMini = [
  { tag: "复盘", title: "一次合作官宣，如何把三个平台的热搜全占了", heat: "342万" },
  { tag: "幕后", title: "经纪人工作群流出？先别急着站队", heat: "298万" },
  { tag: "数据", title: "这场讨论里，谁的发声最能带热搜", heat: "266万" },
];

// ================= 吃瓜合集（合集，专题感最强） =================
export const collectionTabs = [
  "全部专题",
  "人物篇",
  "事件篇",
  "行业篇",
  "考古篇",
];

export const collections: {
  title: string;
  desc: string;
  count: number;
  tag: string;
  category: string;
  cover: string;
}[] = [
  {
    title: "绯闻显微镜",
    desc: "放大、慢放、反复回看，逐条整理每一次互动的来龙去脉。",
    count: 42,
    tag: "人物篇",
    category: "追踪中",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20a%20large%20magnifying%20glass%20over%20scattered%20newspaper%20clippings%2C%20red%20question%20mark%20and%20small%20amber%20stars%2C%20detective%20gossip%20theme%2C%20minimal%20collage%20on%20a%20warm%20cream%20background%20with%20vermilion%20red%20and%20amber%20gold%20accents%2C%20soft%20paper%20grain%20texture%2C%20high%20contrast%2C%20no%20recognizable%20people&width=800&height=600&seq=collection-1-2026&orientation=landscape",
  },
  {
    title: "综艺名场面",
    desc: "把那些被反复剪辑的画面，放回完整上下文里重新看。",
    count: 68,
    tag: "事件篇",
    category: "更新中",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20retro%20television%20set%20with%20a%20large%20play%20button%2C%20confetti%20burst%20and%20variety%20show%20stage%20floor%2C%20minimal%20geometric%20collage%2C%20warm%20terracotta%20cream%20and%20red%20palette%20with%20amber%20lights%2C%20soft%20grainy%20paper%20texture%2C%20high%20contrast%2C%20no%20recognizable%20people%2C%20magazine%20collage%20art&width=800&height=600&seq=collection-2-2026&orientation=landscape",
  },
  {
    title: "片场手记",
    desc: "进组、杀青、路透与番外，一条龙把制作幕后串起来。",
    count: 35,
    tag: "行业篇",
    category: "专题",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20film%20studio%20scene%20with%20a%20director%20chair%2C%20round%20spotlight%20and%20clapperboard%2C%20minimal%20geometric%20collage%20on%20a%20warm%20cream%20background%20with%20vermilion%20red%20and%20amber%20gold%20decorative%20shapes%2C%20soft%20paper%20grain%2C%20high%20contrast%2C%20no%20recognizable%20people%2C%20magazine%20style%20illustration&width=800&height=600&seq=collection-3-2026&orientation=landscape",
  },
  {
    title: "红毯观察",
    desc: "造型、座位、入场顺序，红毯上处处是讲究与暗流。",
    count: 51,
    tag: "人物篇",
    category: "更新中",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20red%20carpet%20entrance%20with%20velvet%20rope%20posts%2C%20flashing%20camera%20lights%20and%20golden%20sparkles%2C%20minimal%20geometric%20collage%2C%20warm%20cream%20and%20red%20palette%20with%20amber%20light%20flashes%2C%20soft%20grainy%20paper%20texture%2C%20high%20contrast%2C%20no%20recognizable%20people%2C%20magazine%20collage%20art&width=800&height=600&seq=collection-4-2026&orientation=landscape",
  },
  {
    title: "舆论风向标",
    desc: "热搜词条与评论区风向，我们帮你分层拆出脉络。",
    count: 29,
    tag: "行业篇",
    category: "追踪中",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20storm%20of%20speech%20bubbles%20and%20hashtag%20symbols%20swirling%20around%20a%20central%20red%20megaphone%2C%20social%20media%20discussion%20theme%2C%20minimal%20collage%20on%20a%20warm%20cream%20background%20with%20red%20and%20amber%20accents%2C%20soft%20paper%20grain%2C%20high%20contrast%2C%20no%20recognizable%20people%2C%20magazine%20illustration&width=800&height=600&seq=collection-5-2026&orientation=landscape",
  },
  {
    title: "神反转考古",
    desc: "把旧料重新排一排，才发现反转早已埋在开头。",
    count: 46,
    tag: "考古篇",
    category: "完结",
    cover: "https://readdy.ai/api/search-image?query=Flat%20vector%20editorial%20illustration%20with%20a%20comic%20style%20burst%2C%20dramatic%20red%20arrows%20and%20spotlights%20arranged%20around%20a%20curved%20flip%20turn%20motif%20symbolizing%20an%20unexpected%20plot%20twist%2C%20minimal%20geometric%20collage%2C%20warm%20cream%20background%20with%20red%20and%20amber%20gold%20shapes%2C%20grainy%20paper%20texture%2C%20high%20contrast%2C%20no%20recognizable%20people&width=800&height=600&seq=collection-6-2026&orientation=landscape",
  },
];

// ================= 快讯汇总（汇总，短讯高密度） =================
export const flashFeed: {
  time: string;
  headline: string;
  source: string;
  tag: string;
  hot?: boolean;
}[] = [
  { time: "12:40", headline: "新物料释出，词条#同框画面#应声登顶", source: "路透转播", tag: "同框", hot: true },
  { time: "12:18", headline: "工作室发长文回应，全文六个字没提争议", source: "工作室", tag: "回应", hot: true },
  { time: "11:52", headline: "录制花絮放出，预告与正片不是一回事", source: "节目组", tag: "幕后" },
  { time: "11:30", headline: "粉丝见面会因故改期，购票观众可全额退款", source: "票务平台", tag: "官方" },
  { time: "11:06", headline: "旧采访被重新解读，讨论区开启考古模式", source: "媒体考古", tag: "考古", hot: true },
  { time: "10:44", headline: "代言的品牌集体撤热搜词条，操作引关注", source: "品牌方", tag: "商业" },
  { time: "10:21", headline: "颁奖礼座位图公布，粉丝连夜排位比数据", source: "红毯观察", tag: "红毯" },
  { time: "09:58", headline: "二创表情包出圈，官方下场点了个赞", source: "网友创作", tag: "二创", hot: true },
  { time: "09:33", headline: "评论区吵了三条热搜，核心争论点只有一句", source: "讨论精选", tag: "讨论" },
];

// ================= 年度盘点（盘点，编辑体大块叙事） =================
export const roundups: {
  no: string;
  title: string;
  kicker: string;
  body: string;
  points: string[];
  stat: string;
  cover: string;
}[] = [
  {
    no: "01",
    title: "一瓜三变的教科书",
    kicker: "年度神反转",
    body: "从一句含糊回应到全员下场，事件在 48 小时内转了三轮方向。把每轮口径、时间点与影响摆上桌面，才算真正读懂这份年度反转样本。",
    points: ["首轮：轻描淡写，评论区先炸", "二轮：补充说明，越描越具体", "三轮：衍生话题反超主瓜热度"],
    stat: "阅读 312 万",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20portrait%20composition%20of%20a%20stacked%20trophy%20and%20small%20crown%20on%20a%20podium%20with%20golden%20confetti%20and%20radiant%20amber%20rays%2C%20year%20roundup%20awards%20theme%2C%20warm%20cream%20background%20with%20vermilion%20red%20and%20amber%20gold%20accents%2C%20minimal%20geometric%20collage%2C%20soft%20paper%20grain%20texture%2C%20high%20contrast%2C%20no%20recognizable%20people%2C%20magazine%20art&width=800&height=1000&seq=roundup-1-2026&orientation=portrait",
  },
  {
    no: "02",
    title: "藏在节目里的名场面",
    kicker: "年度幕后",
    body: "有的名场面靠剪辑封神，有的靠完整版翻盘。这一年最出圈的几个片段，把它们放回上下文里，画面含义几乎反过来。",
    points: ["完整版与预告对照，答案不同", "一句花字成为全年弹幕冠军", "衍生二创数量刷新纪录"],
    stat: "播放 486 万",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20an%20open%20calendar%20marked%20with%20red%20crosses%20and%20a%20rolling%20film%20reel%20below%2C%20event%20timeline%20recap%20theme%2C%20minimal%20collage%20on%20a%20warm%20cream%20terracotta%20background%20with%20red%20and%20amber%20geometric%20accents%2C%20soft%20grainy%20paper%20texture%2C%20high%20contrast%2C%20no%20recognizable%20people%2C%20magazine%20collage%20art&width=800&height=1000&seq=roundup-2-2026&orientation=portrait",
  },
  {
    no: "03",
    title: "热搜指数全景图",
    kicker: "年度数据",
    body: "把全年热搜按人物、事件与行业切片重排，能清楚看见流量如何被制造、迁移与消散。这张图，就是整年吃瓜的缩略目录。",
    points: ["年度讨论峰值出现在第三季度", "事件类热搜留存时间最短", "人物类话题包揽年度最热前十"],
    stat: "收录 1200+ 词条",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20climbing%20bar%20chart%20made%20of%20hearts%20and%20small%20stars%20on%20podium%20steps%2C%20popularity%20review%20theme%2C%20minimal%20collage%20on%20a%20warm%20cream%20background%20with%20red%20and%20amber%20gold%20geometric%20accents%2C%20soft%20paper%20grain%20texture%2C%20high%20contrast%2C%20no%20recognizable%20people%2C%20magazine%20collage%20art&width=800&height=1000&seq=roundup-3-2026&orientation=portrait",
  },
];

// ================= 编辑推荐（推荐，精选小卡 + 推荐理由） =================
export const recommended: {
  title: string;
  reason: string;
  meta: string;
  cover: string;
}[] = [
  {
    title: "老料新读：一张旧合影带出的完整时间线",
    reason: "考据党必看",
    meta: "合集 · 25 条线索",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20an%20old%20photograph%20frame%20with%20clock%20hands%20and%20dotted%20timeline%20linking%20stars%2C%20retro%20archaeology%20theme%2C%20warm%20cream%20background%20with%20red%20and%20amber%20gold%20shapes%2C%20minimal%20collage%2C%20paper%20grain%2C%20high%20contrast%2C%20no%20recognizable%20people&width=600&height=600&seq=rec-1-2026&orientation=squarish",
  },
  {
    title: "路透也能看出戏：放慢十倍再告诉你答案",
    reason: "细节显微镜",
    meta: "精选 · 图文并重",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20a%20film%20frame%20with%20a%20pause%20symbol%20and%20slow%20motion%20wave%20lines%2C%20detail%20analysis%20theme%2C%20warm%20cream%20terracotta%20palette%20with%20red%20and%20amber%20accents%2C%20minimal%20collage%2C%20soft%20grainy%20paper%20texture%2C%20high%20contrast%2C%20no%20recognizable%20people&width=600&height=600&seq=rec-2-2026&orientation=squarish",
  },
  {
    title: "节目剪辑的断句艺术：一句花字能封神",
    reason: "幕后拆解",
    meta: "盘点 · 编辑体",
    cover: "https://readdy.ai/api/search-image?query=Flat%20vector%20editorial%20illustration%20of%20scissors%20and%20editing%20timeline%20tracks%20with%20punctuation%20marks%20and%20star%20bursts%2C%20video%20editing%20theme%2C%20minimal%20collage%20on%20a%20warm%20cream%20background%20with%20vermilion%20red%20and%20amber%20gold%20shapes%2C%20paper%20grain%2C%20high%20contrast%2C%20no%20recognizable%20people&width=600&height=600&seq=rec-3-2026&orientation=squarish",
  },
  {
    title: "红毯排位学：座位与时长背后的讲究",
    reason: "榜单向",
    meta: "排行 · 数据向",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20theater%20seat%20rows%20with%20numbered%20red%20tags%20and%20stage%20spotlight%20beams%2C%20seating%20rank%20theme%2C%20minimal%20collage%2C%20warm%20cream%20and%20terracotta%20palette%20with%20amber%20and%20red%20accents%2C%20grainy%20paper%20texture%2C%20high%20contrast%2C%20no%20recognizable%20people&width=600&height=600&seq=rec-4-2026&orientation=squarish",
  },
  {
    title: "当品牌也开始追热点：联动文案方法论",
    reason: "商业观察",
    meta: "汇总 · 快讯向",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20shopping%20tags%20and%20a%20megaphone%20with%20upward%20trending%20arrows%20and%20hashtags%2C%20brand%20marketing%20theme%2C%20warm%20cream%20background%20with%20red%20and%20amber%20gold%20geometric%20shapes%2C%20minimal%20collage%2C%20soft%20paper%20grain%2C%20high%20contrast%2C%20no%20recognizable%20people&width=600&height=600&seq=rec-5-2026&orientation=squarish",
  },
  {
    title: "评论区社会学：三万条争论绕不开的一句",
    reason: "讨论精选",
    meta: "精选 · 观察向",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20flat%20vector%20illustration%20of%20overlapping%20speech%20bubbles%20forming%20a%20discussion%20cloud%20around%20a%20central%20eye%20icon%2C%20online%20comment%20theme%2C%20minimal%20collage%20on%20a%20warm%20cream%20background%20with%20red%20and%20amber%20accents%2C%20grainy%20paper%20texture%2C%20high%20contrast%2C%20no%20recognizable%20people&width=600&height=600&seq=rec-6-2026&orientation=squarish",
  },
];

// ================= 订阅/追更条 =================
export const ctaText = "怕错过当天的瓜？让 17吃瓜 每天把精选合集推到你面前";

// ================= 页脚 =================
export const footerGroups: { title: string; items: string[] }[] = [
  { title: "内容栏目", items: ["17吃瓜精选", "17吃瓜排行", "17吃瓜推荐"] },
  { title: "检索方式", items: ["17吃瓜合集", "17吃瓜汇总", "17吃瓜盘点"] },
  { title: "关于本站", items: ["追更指南", "专栏作者", "免责声明"] },
];

export const footerTags = [
  "吃瓜新热点", "神反转", "考古现场", "名场面", "红毯观察", "幕后花絮",
  "同框画面", "热搜词条", "二次创作", "评论区风向", "行业观察", "编辑精选",
];